import React, { ReactElement, useEffect } from 'react';

import Spinner from 'atomic/spinner';

import './loading.scss';

interface LoadingProps {
    callback?: () => void;
}

const Loading: React.FC<LoadingProps> = ({ callback }): ReactElement => {
    useEffect(() => callback, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="loading">
            <Spinner isInline={true} />
            <div className="loading__text">
                Pobieranie danych…
            </div>
        </div>
    );
};

export default Loading;
